






<ngx-slick-carousel class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig">
  <div ngxSlickItem *ngFor="let notice of slideData" class="slide">
    <div class="container">

      <button mat-button mat-dialog-close style="float: right; font-weight: 900; font-size:30px; cursor: pointer; display: inline-block;">X</button>

      <div class="content">
        <div class="column" style="vertical-align: middle; width: 45%; display: inline-block; ">
          <img src="../../assets/image/notice_logo.PNG" />
        </div>
        <div class="column" style="vertical-align: top; width: 45%; display: inline-block;">
          <h1 style="font-size: 30px; font-weight: bold; line-height:1.3;">
            {{ notice.title }}
          </h1>
          <p>
            {{notice.content}}
          </p>
          <p *ngIf="notice.attachmentId != undefined">
            <button mat-raised-button color="primary" (click)="FileDown(notice, $event)"><span class="material-icons">file_download</span>{{ notice.attachmentId  | attach | async}}</button>&nbsp;
          </p>
        </div>
      </div>

      <mat-dialog-actions style="float: right;  display: inline-block;">
        <button mat-button mat-dialog-close color="warn" (click)="setLocalStorageWithExpiry(notice.id, notice)">24시간동안 보지 않기</button>
      </mat-dialog-actions>
    </div>
  </div>
</ngx-slick-carousel>





